"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVoilaFilter = exports.VOILA_FILTERS = exports.VOILA_FILTER_QUALITY = void 0;
const filters_1 = require("./filters");
const getPencilAPIUrl = (hostname, quality) => `https://${hostname}/mixtiles-pencil-sketch-${quality}/v1_0/group`;
const getColorPencilAPIUrl = (hostname, quality) => `https://${hostname}/mixtiles-color-pencil-${quality}/v1_0/group`;
const getDigitalOilAPIUrl = (hostname, quality) => `https://${hostname}/mixtiles-digital-oil-painting-${quality}/v1_0/group`;
exports.VOILA_FILTER_QUALITY = {
    SD: 'sd',
    HD: 'hd'
};
exports.VOILA_FILTERS = [
    {
        id: filters_1.FILTERS.PENCIL,
        removeBackground: false,
        getApiUrl: getPencilAPIUrl
    },
    {
        id: filters_1.FILTERS.PENCIL_NO_BG,
        removeBackground: true,
        getApiUrl: getPencilAPIUrl
    },
    {
        id: filters_1.FILTERS.DIGITAL_OIL,
        removeBackground: false,
        getApiUrl: getDigitalOilAPIUrl
    },
    {
        id: filters_1.FILTERS.DIGITAL_OIL_NO_BG,
        removeBackground: true,
        getApiUrl: getDigitalOilAPIUrl
    },
    {
        id: filters_1.FILTERS.COLOR_PENCIL,
        removeBackground: false,
        getApiUrl: getColorPencilAPIUrl
    },
    {
        id: filters_1.FILTERS.COLOR_PENCIL_NO_BG,
        removeBackground: true,
        getApiUrl: getColorPencilAPIUrl
    }
];
function isVoilaFilter(filterId) {
    return exports.VOILA_FILTERS.map(filter => filter.id).includes(filterId);
}
exports.isVoilaFilter = isVoilaFilter;
//# sourceMappingURL=voilaFilters.js.map